<template>
  <div class="feedback-section">
    <div class="feedback-header">
      <p>编辑反馈</p>
    </div>
    <div class="feedback-main">
      <div class="select-form">
        <el-form
          style="font-size: 12px;"
          label-width="80px"
          size="mini"
          :model="feedback"
          ref="feedback"
          :rules="Rule"
        >
          <el-form-item label="选择课件" prop="courseware_id">
            <el-select
              v-model="feedback.courseware_id"
              placeholder="请选择课件"
              @change="handleChangeCourseware"
              class="form-input"
            >
              <el-option
                v-for="item in coursewareList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <div class="Courseware-container" v-if="courseware.name">
              <img
                :src="courseware.image.file_src"
                alt=""
                class="courseware-image"
              />
              <p class="title">{{ courseware.name }}</p>
              <p class="desc">{{ courseware.content }}</p>
            </div>
          </el-form-item>
          <el-form-item label="反馈内容" prop="remarks">
            <el-input
              type="textarea"
              placeholder="填写您的反馈内容..."
              rows="6"
              v-model="feedback.remarks"
              class="form-textarea"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-button @click="handleSubmit" class="save-button">提交</el-button>
      <el-button @click="() => this.$router.back()" class="return-button"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
import classService from "@/global/service/class";
import userService from "@/global/service/user";

export default {
  data() {
    return {
      courseware: {},
      feedback: {
        courseware_id: null,
        remarks: ""
      },
      coursewareList: [],
      gradeData: [],
      Rule: {
        courseware_id: {
          required: true,
          message: "请选择课件",
          trigger: "change"
        },
        remarks: [{ required: true, message: "请填写反馈", trigger: "blur" }]
      }
    };
  },
  created() {
    this.getData();
    this.getCourseWare();
  },
  methods: {
    handleSubmit() {
      this.$refs.feedback.validate(valid => {
        if (valid) {
          let id = this.$route.params.id;
          const params = {
            courseware_id: this.feedback.courseware_id,
            remarks: this.feedback.remarks
          };
          userService.coursewareFeedBackEdit(id, params).then(() => {
            this.$message.success("编辑成功");
            this.$router.push({
              name: "my_feedback"
            });
          });
        }
      });
    },
    getData() {
      let id = this.$route.params.id;
      userService.coursewareFeedBackDetail(id).then(res => {
        this.feedback = {
          courseware_id: res.courseware.id,
          remarks: res.remarks
        };
        this.handleChangeCourseware(res.courseware.id);
      });
    },
    getCourseWare() {
      this.loading = true;
      classService
        .coursewareList()
        .then(res => {
          this.coursewareList = res.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangeCourseware(e) {
      classService.coursewareDetail(e).then(res => {
        this.courseware = res;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.feedback-section {
  color: #2c3e50;
  font-size: 12px;
  .feedback-header {
    display: flex;
    align-items: center;
    background: #ffffff;
    height: 40px;
    padding-left: 20px;
  }
  .feedback-main {
    margin-top: 10px;
    background: #ffffff;
    text-align: left;
    padding-bottom: 20px;
    .select-form {
      padding-top: 20px;
      padding-left: 20px;
      .el-form {
        .el-form-item {
          width: 48%;
        }
      }
    }
  }
  .form-input {
    width: 230px;
  }
  .form-textarea {
    width: 500px;
  }
  .Courseware-container {
    margin-top: 20px;
    width: 230px;
    .courseware-image {
      width: 230px;
      height: 160px;
      object-fit: cover;
    }
    .title {
      font-size: 14px;
      color: #333;
      line-height: 30px;
      border-bottom: 1px solid #dedede;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .desc {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-top: 10px;
      font-size: 12px;
      color: #666666;
    }
  }
  .return-button {
    font-size: 12px;
    width: 56px;
    height: 32px;
    padding: 0;
    color: #f0b32f;
    border: 1px solid #f0b32f;
  }
  .save-button {
    font-size: 12px;
    width: 56px;
    height: 32px;
    padding: 0;
    color: #ffffff;
    background: #f0b32f;
    margin-left: 100px;
  }
  .feedback-container {
    padding: 20px;
    text-align: left;
    .button-content {
      padding-top: 10px;
    }
  }
}
</style>
